export default {"src":"/_next/static/media/movie.3b9191ab.svg","height":11,"width":14};